
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'CheckEvent'
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  dialogEventVisible!: Boolean;

  @Prop({
    type: Object,
    default: () => ({})
  })
  dialogEventData!: {};

  private attributeList: any = [
    {
      label: '备注',
      value: 2
    },
    {
      label: '当前值',
      value: 3
    },
    {
      label: '照片',
      value: 5
    },
    {
      label: '视频',
      value: 6
    },
    {
      label: '视频(仅异常必传)',
      value: 7
    }
  ];

  private formEvent = {
    id: '',
    check_name: '',
    attribute_arr: [],
    start_time: '',
    end_time: ''
  };

  // 7和6互斥这里判断下
  attributeChange(val: any) {
    if (val.length > 0) {
      if (val[val.length - 1] === 7) {
        this.arrRemove(val, 6);
      }
      if (val[val.length - 1] === 6) {
        this.arrRemove(val, 7);
      }
    }
    this.formEvent.attribute_arr = val;
  }

  private arrRemove(val: any, p:any) {
    var index = val.indexOf(p);
    if (index > -1) {
      val.splice(index, 1);
    }
  }

  getEditData() {
    this.formEvent.id = (this.dialogEventData as any).id;
    this.formEvent.check_name = (this.dialogEventData as any).check_name;
    this.formEvent.attribute_arr = (this.dialogEventData as any).attribute_arr;
    this.formEvent.start_time = (this.dialogEventData as any).start_time;
    this.formEvent.end_time = (this.dialogEventData as any).end_time;
  }

  private doCheck() {
    let _this = this;

    if (
      this.formEvent.check_name.trim().length === 0 ||
      this.formEvent.check_name.trim().length > 20
    ) {
      this.$notify({
        title: '提示',
        message: '请输入1~20位字符的事件名称',
        offset: 100,
        type: 'warning'
      });
      return false;
    }
    if (!this.formEvent.start_time || !this.formEvent.end_time) {
      this.$notify({
        title: '提示',
        message: '请填写点检时间',
        offset: 100,
        type: 'warning'
      });
      return false;
    }

    this.$emit('conform', this.formEvent);
  }

  close() {
    this.$emit('close', false);
  }
}
